import { React, useEffect, useState } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { Pencil, CheckLg, XLg } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";

import Loader from "../components/Loader";
import Message from "../components/Message";
import { setCredentials } from "../slices/authSlice";
import { IoLogoWhatsapp } from "react-icons/io";

import { toast } from "react-toastify";
import { getCurrentDate, getCurrentTime } from "../utils/getCurrentDate";
import { useGetAllWsMessagesQuery } from "../slices/wsMessageSlice";
import { openWhatsApp } from "../utils/generalUtilities";

const WsMessagesScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [editEnabled, setEditEnabled] = useState("");

  const [filterSelect, setFilterSelect] = useState("Date Filter");
  const [filterValue, setFilterValue] = useState(`&status=Not Contacted`);
  const [startPincode, setStartPincode] = useState(
    userInfo?.customersStartPincode ? userInfo?.customersStartPincode : 600001
  );
  const [endPincode, setEndPincode] = useState(
    userInfo?.customersEndPincode ? userInfo?.customersEndPincode : 700000
  );
  const [startDate, setStartDate] = useState(getCurrentDate());

  const [endDate, setEndDate] = useState(getCurrentDate());

  const [getApiQuery, setGetApiQuery] = useState(
    `createdAt[gte]=${startDate}&createdAt[lte]=${endDate}T23:59:59.000Z&sort=-createdAt`
  );
  const [messages, setMessages] = useState([]);
  const [messageToList, setMessageToList] = useState([]);
  const [messageType, setMessageType] = useState("All");

  const dispatch = useDispatch();

  let {
    data: allMessages,
    isLoading,
    error,
    refetch,
  } = useGetAllWsMessagesQuery({
    token: userInfo?.token,
    query: getApiQuery,
  });

  const handleGetCustomers = async () => {
    if (startPincode > endPincode)
      toast.error("From Pincode can not be greater than To Pincode");
    else {
      // setEndDate(getCurrentDate() + getCurrentTime());

      setGetApiQuery(
        `createdAt[gte]=${startDate}&createdAt[lte]=${endDate}T23:59:59.000Z&sort=-createdAt`
      );

      dispatch(
        setCredentials({
          ...userInfo,
          customersStartPincode: startPincode,
          customersEndPincode: endPincode,
        })
      );
    }
  };

  useEffect(() => {
    refetch();
  }, [refetch, editEnabled]);

  useEffect(() => {
    const msgs = isLoading ? [] : error ? [] : allMessages ? allMessages : [];
    setMessages(msgs);
    setMessageToList(msgs);
  }, [setMessages, allMessages, isLoading, error]);

  useEffect(() => {
    if (messageType === "All") {
      setMessageToList(messages);
      return;
    }
    const msgs = messages
      ? messages.filter((msg) => msg.typeOfMessage === messageType)
      : [];
    console.log(messageType);
    console.log(msgs);
    setMessageToList(msgs);
  }, [messageType, setMessages, allMessages, messages, isLoading, error]);
  return (
    <>
      <strong>Message History</strong>

      <Row
        className="mb-2"
        style={{
          margin: "auto",
          width: "95%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {filterSelect === "Date Filter" ? (
          <>
            {" "}
            <Col xs={6} md="auto" sm={6}>
              <Form.Group controlId="visitorMobile">
                <Form.Control
                  type="date"
                  placeholder="2023-11-23"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                ></Form.Control>{" "}
              </Form.Group>
            </Col>
            <Col xs={6} md="auto" sm={6}>
              <Form.Group controlId="visitorMobile">
                <Form.Control
                  type="date"
                  placeholder="2023-11-27"
                  value={endDate?.split("T")[0]}
                  onChange={(e) => setEndDate(e.target.value)}
                ></Form.Control>{" "}
              </Form.Group>
            </Col>
          </>
        ) : (
          <></>
        )}

        <Col xs={6} md="auto" sm={6} className="d-flex justify-content-center">
          <Form.Group className="my-1" controlId="gymType">
            <Button
              id="filterBy"
              value={filterValue}
              onClick={handleGetCustomers}
            >
              Get Messages
            </Button>
          </Form.Group>
        </Col>
        <Col xs={12} md="auto" sm={6}>
          <Form.Group as={Row} controlId="visitorMobile">
            <Button style={{ backgroundColor: "#27aa67" }}>
              Messages :<strong> {messageToList?.length}</strong>
            </Button>
          </Form.Group>
        </Col>
      </Row>
      <Row
        className="mb-1"
        style={{
          justifyContent: "center",
          margin: "auto",
        }}
      >
        <Button
          className="marginPointOne sixteenWidth numbersButton"
          onClick={() => setMessageType("All")}
        >
          All {messages.length}
        </Button>
        <Button
          className="marginPointEight sixteenWidth buttonGreen numbersButton"
          onClick={() => setMessageType("Subscription")}
        >
          Subs WS{" "}
          {
            messages?.filter((msg) => msg.typeOfMessage === "Subscription")
              .length
          }
        </Button>
        <Button
          className="marginPointOne sixteenWidth buttonPeach numbersButton"
          onClick={() => setMessageType("Subscription_SMS")}
        >
          {messageType} Subs SMS{" "}
          {
            messages?.filter((msg) => msg.typeOfMessage === "Subscription_SMS")
              .length
          }
        </Button>
        <Button
          className="marginPointEight sixteenWidth buttonGreen numbersButton"
          onClick={() => setMessageType("Renewal")}
        >
          Ren WS{" "}
          {messages?.filter((msg) => msg.typeOfMessage === "Renewal").length}
        </Button>
        <Button
          className="marginPointOne sixteenWidth buttonPeach numbersButton"
          onClick={() => setMessageType("Renewal_SMS")}
        >
          Ren SMS{" "}
          {
            messages?.filter((msg) => msg.typeOfMessage === "Renewal_SMS")
              .length
          }
        </Button>
        <Button
          className="marginPointOne sixteenWidth buttonTeal numbersButton"
          onClick={() => setMessageType("Renewal Reminder")}
        >
          Renewal Rem{" "}
          {
            messages?.filter((msg) => msg.typeOfMessage === "Renewal Reminder")
              .length
          }
        </Button>
        <Button
          className="marginPointOne sixteenWidth buttonMaroon numbersButton"
          onClick={() => setMessageType("InActive Reminder")}
        >
          InActive Rem{" "}
          {
            messages?.filter((msg) => msg.typeOfMessage === "InActive Reminder")
              .length
          }
        </Button>
        <Button
          className="marginPointOne sixteenWidth buttonOlive numbersButton"
          onClick={() => setMessageType("Birthday")}
        >
          Birthday{" "}
          {messages?.filter((msg) => msg.typeOfMessage === "Birthday").length}
        </Button>
        <Button className="marginPointOne sixteenWidth buttonGreen numbersButton">
          Company # {messages?.filter((msg) => msg.cloudMessageId).length}
        </Button>
        <Button className="marginPointOne sixteenWidth numbersButton">
          Own # {messages?.filter((msg) => !msg.cloudMessageId).length}
        </Button>
        <Button
          className="marginPointOne sixteenWidth numbersButton"
          onClick={() => setMessageType("WhatsApp_Ad")}
        >
          WhatsApp Ad{" "}
          {
            messages?.filter((msg) => msg.typeOfMessage === "WhatsApp_Ad")
              .length
          }
          (
          {
            messages?.filter(
              (msg) =>
                msg.typeOfMessage === "WhatsApp_Ad" &&
                msg.messageResponse !== "failed"
            ).length
          }
          )
        </Button>
        <Button
          className="marginPointOne sixteenWidth numbersButton"
          onClick={() => setMessageType("From_Customer")}
        >
          From Cust{" "}
          {
            messages?.filter((msg) => msg.typeOfMessage === "From_Customer")
              .length
          }
        </Button>
        <Button
          className="marginPointOne sixteenWidth numbersButton"
          onClick={() => setMessageType("Reply_to_Customer")}
        >
          Reply To Cust{" "}
          {
            messages?.filter((msg) => msg.typeOfMessage === "Reply_to_Customer")
              .length
          }
        </Button>
      </Row>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message>{error.data.error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive="sm">
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Gym</th>
                <th style={{ textAlign: "left" }}>Member</th>
                {/* <th>Pincode</th> */}
                <th style={{ textAlign: "left" }}>Mobile</th>
                <th style={{ textAlign: "left" }}>Type</th>
                {/* <th>Contacted Via</th> */}
                <th style={{ textAlign: "left" }}>Status</th>
                <th style={{ textAlign: "left" }}>In-Out</th>
                <th style={{ textAlign: "left" }}>Time </th>
                <th style={{ textAlign: "left" }}>Text</th>
              </tr>
            </thead>
            <tbody>
              {messageToList ? (
                messageToList?.map((msg) => (
                  <>
                    <tr>
                      <td style={{ textAlign: "left", maxWidth: "200px" }}>
                        {msg.gymId}
                      </td>
                      <td style={{ textAlign: "left" }}>{msg.userId}</td>
                      {/* <td>{customer.pincode}</td> */}
                      <td style={{ textAlign: "left" }}>{msg.mobileNumber}</td>
                      <td style={{ textAlign: "left" }}>{msg.typeOfMessage}</td>
                      {/* <td>{customer.reachedThrough}</td> */}
                      <td style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                        {msg.messageResponse?.length < 20
                          ? msg.messageResponse
                          : "Sent"}
                      </td>
                      <td style={{ textAlign: "left" }}>{msg.messageKind}</td>
                      <td style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                        {new Date(msg.createdAt).toLocaleDateString() +
                          " " +
                          new Date(msg.createdAt).toLocaleTimeString()}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {msg.messageContent}
                        {(msg.typeOfMessage === "From_Customer" ||
                          msg.typeOfMessage === "Reply_to_Customer") && (
                          <button
                            style={{
                              border: "none",
                              color: "green",
                              background: "transparent",
                              padding: "0px",
                              cursor: "pointer",
                              margin: "0px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            onClick={(e) =>
                              openWhatsApp(
                                msg.mobileNumber,
                                "whatsAppAd",
                                null,
                                null,
                                null
                              )
                            }
                          >
                            <IoLogoWhatsapp />
                          </button>
                        )}
                      </td>

                      {/* <td>
                          <button
                            style={{ borderRadius: "20%" }}
                            onClick={() => {
                              setGymName(customer.gymName);
                              setEditEnabled(customer._id);
                              setGymLocation(customer.gymLocation);
                              setNotes(customer.notes);
                              setMobileNumber(customer.mobileNumber);
                              setSecondaryNumber(customer.secondaryNumber);
                              // setPincode(customer.pincode);
                              setReachedThrough(customer.reachedThrough);
                              setContactedDate(customer.contactedDate);
                              setStatus(customer.status);
                            }}
                          >
                            <Pencil />
                          </button>
                        </td> */}
                    </tr>
                  </>
                ))
              ) : (
                <Message>No visitors Available</Message>
              )}
            </tbody>
          </Table>
        </>
      )}
    </>
  );
};

export default WsMessagesScreen;
